<template>
  <el-form ref="formRef" :model="form" class="company-info_form" label-width="120px"
           :label-position="getIsMobile?'top':'right'">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="接受人">
          <el-input ref="inputRef" placeholder="请选择接受人" type="text" v-model="form.name" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input placeholder="请输入部门" type="text" v-model="form.bumen"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="电话">
          <el-input placeholder="请输入电话" type="text" v-model="form.lxrtel"/>
        </el-form-item>
        <el-form-item label="手机">
          <el-input placeholder="请输入手机号" type="text" v-model="form.lxrphone"/>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="传真">
          <el-input placeholder="请输入传真" type="text" v-model="form.lxrmax"/>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input placeholder="请输入邮箱" type="text" v-model="form.email"/>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import useRootSetting from '@/hooks/useRootSetting'
import { defineComponent, reactive ,ref,watch,toRefs} from '@vue/composition-api'

export default defineComponent({
  components: {},
  props: {
    companyInfo: {
      type: Object,
      default: () => {}
    },
    allInfo: {
      type: Object,
      default: () => {}
    },
    editInfo: {
      type: Object,
      default: () => {return {}}
    }
  },
  setup(props, { emit }) {
    const { getIsMobile } = useRootSetting()
    const defaultForm = () => ({
      name: '',
      bumen: '',
      lxrtel: '',
      lxrphone: '',
      lxrmax: '',
      email: ''
    })
    const form = reactive(defaultForm())
    const formRef = ref(null)


    //清掉公司名，其余信息都被清除
    watch(()=>form.name, (val)=> {
      if(val === '') Object.assign(form,defaultForm())
    },{immediate:true,deep:true})


    const reactiveInfo = toRefs(props.allInfo);

    //选完联系人给所有信息赋值
    watch(()=>reactiveInfo, (val)=> {
      Object.assign(form,val)
    },{immediate:true,deep:true})

    watch(()=> props.editInfo,(val)=>{
      const {name,bumen,lxrtel,lxrphone,lxrmax,email} = val
      Object.assign(form, { name, bumen, lxrtel, lxrphone, lxrmax, email });
    },{immediate:true})

    return {
      formRef,
      form,
      getIsMobile
    }
  }
})
</script>
